export const CORE_EXPERTISE_OPTIONS = [
  "Child",
  "Adolescent",
  "Adult",
  "Older Adult",
  "Family",
  "Relationship",
];

export const APPOINTMENT_TYPE_OPTIONS = ["In person", "Telehealth"];

const EXPERTISE_ALIASES = {
  "adult psychiatry": "Adult",
  "psychiatry (general adult)": "Adult",
  "general adult psychiatry": "Adult",
  "youth psychiatry": "Adolescent",
  "child psychiatry": "Child",
  "child & adolescent": "Child, Adolescent",
  "child and adolescent": "Child, Adolescent",
  "child and adolescent psychiatry": "Child, Adolescent",
  "older adults / geriatric": "Older Adult",
  "older adults": "Older Adult",
  "geriatric psychiatry": "Older Adult",
  couples: "Relationship",
  relationships: "Relationship",
  "family therapy": "Family",
  "relationships & family": "Relationship, Family",
};

export const normaliseExpertise = (value) => {
  const cleaned = String(value || "").trim();
  return EXPERTISE_ALIASES[cleaned.toLowerCase()] || cleaned;
};

export const normaliseExpertiseList = (values) => [
  ...new Set(
    (values || [])
      .flatMap((value) => normaliseExpertise(value).split(","))
      .map((value) => value.trim())
      .filter(Boolean),
  ),
];

export const matchesExpertiseSearch = (value, query) => {
  const needle = String(query || "").trim().toLowerCase();
  if (!needle) return true;
  const searchable = normaliseExpertise(value).toLowerCase();
  if (searchable.includes(needle)) return true;
  return needle.includes("youth") && searchable.includes("adolescent");
};
